export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/marketing.3ac92f0.svg";